<template>
  <GlobalWindow
    :visible.sync="isVisibled"
    :show="true"
    title="复制"
    width="92%"
    @confirm="confirm"
    @close="(selectData = []), (currency = {cropNum: '',is_title: '0',is_notice: '0',is_repeat_submit: '0',launch_id: '',source_num:''}),$emit('guanbi')"
  >
    <div class="top">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-input
            v-model="mpAdvertiserListParams.account_id"
            placeholder="请输入广告账户id"
            rows="8"
          >
            <!-- @input="($event)=>{
              mpAdvertiserListParams.job_id = handleParams($event)
            }" -->
            <i
              slot="prefix"
              class="el-input__icon el-icon-search"
            />
          </el-input>
        </el-col>
        <el-button
          type="primary"
          @click="searchMpAdvert"
        >搜索</el-button>
        <el-button
          type="primary"
          @click="resetMpAdvertList"
        >重置</el-button>
        <el-button
          type="primary"
          @click="clearSelect"
        >清空选项</el-button>
      </el-row>
    </div>

    <div class="center-container">
      <div class="center-left">
        <el-table
          v-if="mpAdvertiserList"
          ref="multipleTable"
          v-loading="isLoading"
          :data="mpAdvertiserList"
          :row-key="getRowKeys"
          border
          tooltip-effect="dark"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
            align="center"
          />
          <el-table-column
            prop="account_id"
            label="广告主id"
            width="170"
            align="center"
          />
          <el-table-column
            prop="advertiser_name"
            label="广告主名称"
            width="250"
            align="center"
          >
            <template scope="scope">
              <p
                class="overflow"
                :title="scope.row.advertiser_name"
              >{{ scope.row.advertiser_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            label="复制的量"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].num"
                class="input"
                type="number"
                min="1"
                max="50"
                placeholder="复制的量"
                @input="judge(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            label="项目名称"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].name"
                placeholder="项目名称"
              />
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="备注"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].remark"
                placeholder="请输入备注"
              />
              <!-- @input="($event)=>{
                  selectData.filter((item)=>{
                    return item.id === scope.row.id
                  })[0].remark = handleParams($event)
                }" -->
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="广告状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].operation"
                placeholder="请选择"
              >
                <el-option
                  label="开启"
                  :value="'ENABLE'"
                />
                <el-option
                  label="关闭"
                  :value="'DISABLE'"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="开始时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].begin_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                :picker-options="pickerOptions"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="结束时间"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-date-picker
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].end_time"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期"
                :picker-options="pickerOptions"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="投放产品"
            align="center"
            width="130"
          >
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].app_id"
                class="input"
                type="number"
                min="1"
                placeholder="投放产品"
                @input="judgetwo(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            label="自定义标签"
            align="center"
          >
            <template slot-scope="scope">
              <el-input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].keywords"
                placeholder="请输入自定义标签"
              />
              <!-- @input="($event)=>{
                  selectData.filter((item)=>{
                    return item.id === scope.row.id
                  })[0].keywords = handleParams($event)
                }" -->
            </template>
          </el-table-column>
          <el-table-column
            label="素材数量"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].material_num"
                class="input"
                type="number"
                min="1"
                max="30"
                placeholder="素材数量"
                @input="judgethree(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <el-table-column
            label="素材来源"
            align="center"
          >
            <template slot-scope="scope">
              <el-select
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].material_source"
                placeholder="请选择"
              >
                <el-option
                  label="ADXray"
                  :value="1"
                />
                <el-option
                  label="变色龙"
                  :value="2"
                />
                <el-option
                  label="各占一半"
                  :value="3"
                />
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            label="小程序链接"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length && selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].url_id!=''"
                style="margin-right:10px"
                type="success"
              >{{ selectData.filter((item)=>{
                return item.id === scope.row.id
              })[0].url_remark }}</el-tag>
              <el-button
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                size="mini"
                type="primary"
                @click="inwerwq(scope.row)"
              >选择</el-button>
            </template>
          </el-table-column>
          <el-table-column
            label="预算金额"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <el-radio-group
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].budget_mode"
                size="mini"
              >
                <el-radio-button :label="0">有限</el-radio-button>
                <el-radio-button :label="-1">无限</el-radio-button>
              </el-radio-group>

              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length && selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].budget_mode == 0"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].budget"
                class="input"
                type="number"
                min="300"
                max="9999999"
                style="width:110px"
                placeholder="不少于300元，不超过9999999"
                @blur="judgekoiwsr(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
              <!-- <span
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                style="color:#F56C6C"
              >不少于300元，不超过9999999</span> -->
            </template>
          </el-table-column>
          <el-table-column
            label="出价系数"
            align="center"
            width="100"
          >
            <template slot-scope="scope">
              <input
                v-if="selectData.filter((item)=>{
                  return item.id === scope.row.id
                }).length"
                v-model="selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0].search_bid_ratio"
                class="input"
                type="number"
                min="1"
                max="2"
                placeholder="推荐出价系数1.05，预估跑量可提升10%-20%"
                @input="judgekqaw(selectData.filter((item)=>{
                  return item.id === scope.row.id
                })[0],$event)"
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            prop="agent_name"
            label="组织"
            width="200"
          >
            <template scope="scope">
              <p class="overflow" :title="scope.row.agent_name">{{ scope.row.agent_name }}</p>
            </template>
          </el-table-column>
          <el-table-column
            prop="company"
            label="公司"
            width="200"
          >
            <template scope="scope">
              <p class="overflow" :title="scope.row.company">{{ scope.row.company }}</p>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
    </div>

    <PaginationRight
      :total="total"
      :page.sync="mpAdvertiserListParams.page"
      :limit.sync="mpAdvertiserListParams.page_size"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

    <div
      v-if="Object.keys(selectData).length !== 0"
      style="overflow: hidden;"
    >
      <div
        class="center-right"
        style="margin-bottom:10px"
      >
        <h3 style="margin-bottom: 4px;">通用改动：此改动会影响全局</h3>
        <table border="1">
          <thead>
            <tr>
              <td
                class="wlewrw"
                style="width:70px;padding: 5px;"
              >复制的量</td>
              <td
                class="wlewrw"
                style="width:70px"
              >项目名称</td>
              <td
                class="wlewrw"
                style="width:70px"
              >备注</td>
              <td
                class="wlewrw"
                style="width:70px"
              >广告状态</td>
              <td
                class="wlewrw"
                style="width:70px"
              >投放开始日期</td>
              <td
                class="wlewrw"
                style="width:70px"
              >投放结束日期</td>
              <td
                class="wlewrw"
                style="width:70px"
              >投放产品</td>
              <td
                class="wlewrw"
                style="width:100px"
              >自定义标签</td>
              <td
                class="wlewrw"
                style="width:70px"
              >素材数量</td>
              <td
                class="wlewrw"
                style="width:70px"
              >素材来源</td>
              <td
                class="wlewrw"
                style="width:130px"
              >小程序链接</td>
              <td
                class="wlewrw"
                style="width:130px"
              >项目预算</td>
              <td
                class="wlewrw"
                style="width:130px"
              >预算金额</td>
              <td
                class="wlewrw"
                style="width:130px"
              >出价系数</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <el-input
                  v-model="currency.cropNum"
                  placeholder="请输入复制的量"
                  @input="currency.cropNum = $event.replace(/[^\d]/g, ''),handleCurrencyCropNum()"
                />
              </td>
              <td>
                <el-input
                  v-model="currency.name"
                  placeholder="请输入项目名称"
                  @input="selectData.forEach(item => item.name = currency.name)"
                />
                <!-- currency.remark = handleParams($event),  -->
              </td>
              <td>
                <el-input
                  v-model="currency.remark"
                  placeholder="请输入备注"
                  @input="selectData.forEach(item => item.remark = currency.remark)"
                />
                <!-- currency.remark = handleParams($event),  -->
              </td>
              <td>
                <el-select
                  v-model="currency.operation"
                  placeholder="请选择"
                  @change="selectData.forEach(item => item.operation = currency.operation)"
                >
                  <el-option
                    label="开启"
                    :value="'ENABLE'"
                  />
                  <el-option
                    label="关闭"
                    :value="'DISABLE'"
                  />
                </el-select>
              </td>
              <td>
                <el-date-picker
                  v-model="currency.begin_time"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
                  placeholder="选择开始日期"
                  style="width: 130px;"
                  @change="handleCurrencyCropBegin_time()"
                />
              </td>
              <td>
                <el-date-picker
                  v-model="currency.end_time"
                  type="date"
                  :disabled="!currency.begin_time"
                  :picker-options="pickerOptions"
                  placeholder="选择结束日期"
                  value-format="yyyy-MM-dd"
                  style="width: 130px;"
                  @change="handleCurrencyCropEnd_time()"
                />
              </td>
              <td>
                <el-input
                  v-model="currency.launch_id"
                  placeholder="请输入投放产品id"
                  @input="currency.launch_id = $event.replace(/[^\d]/g, ''),handleCurrencyCropNumse()"
                />
              </td>
              <td>
                <el-input
                  v-model="currency.keywords"
                  placeholder="请输入素材关键字"
                  @input="selectData.forEach(item => item.keywords = currency.keywords)"
                />
              </td>
              <!-- currency.keywords = handleParams($event),  -->
              <td>
                <el-input
                  v-model="currency.source_num"
                  placeholder="请输入素材数量"
                  @input="currency.source_num = $event.replace(/[^\d]/g, ''),handleCurrencyCropNumsuerw()"
                />
              </td>
              <td>
                <el-select
                  v-model="currency.material_source"
                  placeholder="请选择"
                  style="width: 100px;"
                  @change="selectData.forEach(item => item.material_source = currency.material_source)"
                >
                  <el-option
                    label="ADXray"
                    :value="1"
                  />
                  <el-option
                    label="变色龙"
                    :value="2"
                  />
                  <el-option
                    label="各占一半"
                    :value="3"
                  />
                </el-select>
              </td>
              <td style="text-align:center">
                <el-button
                  type="text"
                  @click="allchooserw"
                >选择</el-button>
              </td>
              <td style="text-align:center">
                <el-radio-group
                  v-model="currency.statuser"
                  size="mini"
                  @change="cuchangerstatus"
                >
                  <el-radio-button :label="0">有限</el-radio-button>
                  <el-radio-button :label="-1">无限</el-radio-button>
                </el-radio-group>
              </td>
              <td style="text-align:center">
                <el-input
                  v-model="currency.objyunum"
                  style="width: 200px;"
                  type="number"
                  min="300"
                  placeholder="不少于300元，不超过9999999"
                  @blur="handleCurrencyCropNumsuerwyuw"
                />
              </td>
              <td style="text-align:center">
                <el-input
                  v-model="currency.chujiaxishu"
                  style="width: 130px;"
                  type="number"
                  min="1"
                  max="2"
                  placeholder="范围1-2"
                  @input="handleCurrencyCropNumschujiaxs"
                />
              </td>
            </tr>
          </tbody>
        </table>

      </div>
      <h3 v-if="Object.keys(selectData).length !== 0">已选：{{ selectData.length }}个</h3>
      <div
        class="center-right"
        style="max-height:430px;overflow-y: auto;"
      >

        <table border="1">
          <thead>
            <tr>
              <td style="width:140px;text-align: center;padding: 5px;">目标广告账户</td>
              <td style="width:130px;text-align: center;">目标广告账户名称</td>
              <td style="width:70px;text-align: center;">复制的量</td>
              <td style="width:70px;text-align: center;">广告状态</td>
              <td style="width:70px;text-align: center;">项目名称</td>
              <td style="width:70px;text-align: center;">备注</td>
              <td style="width:120px;text-align: center;">投放开始日期</td>
              <td style="width:120px;text-align: center;">投放结束日期</td>
              <td style="width:70px;text-align: center;">投放产品</td>
              <td style="width:115px;text-align: center;">自定义标签</td>
              <td style="width:70px;text-align: center;">素材数量</td>
              <td style="width:70px;text-align: center;">素材来源</td>
              <td style="width:130px;text-align: center;">小程序链接</td>
              <td style="width:130px;text-align: center;">项目预算</td>
              <td style="width:130px;text-align: center;">预算金额</td>
              <td style="width:130px;text-align: center;">出价系数</td>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item in selectData"
              :key="item.id"
            >
              <td class="wlewrw">{{ item.account_id }}</td>
              <td class="wlewrw">{{ item.advertiser_name }}</td>
              <td class="wlewrw">{{ item.num }}</td>
              <td class="wlewrw">{{ item.operation==='ENABLE'? '开启': '关闭' }}</td>
              <td class="wlewrw">{{ item.name }}</td>
              <td class="wlewrw">{{ item.remark }}</td>
              <td class="wlewrw">{{ item.begin_time }}</td>
              <td class="wlewrw">{{ item.end_time }}</td>
              <td class="wlewrw">{{ item.app_id }}</td>
              <td class="wlewrw">{{ item.keywords }}</td>
              <td class="wlewrw">{{ item.material_num }}</td>
              <td
                v-if="item.material_source === 1"
                class="wlewrw"
              >ADXray</td>
              <td
                v-if="item.material_source === 2"
                class="wlewrw"
              >变色龙</td>
              <td
                v-if="item.material_source === 3"
                class="wlewrw"
              >各占一半</td>
              <td class="wlewrw">{{ item.url_remark }}</td>
              <td class="wlewrw">{{ item.budget_mode == 0 ? '有限' : '无限' }}</td>
              <td class="wlewrw"><span v-if="item.budget_mode == 0">{{ item.budget }}</span></td>
              <td class="wlewrw">{{ item.search_bid_ratio }}</td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
    <el-dialog
      title="选择小程序链接"
      :visible.sync="dialogVisible"
      :append-to-body="true"
      width="37%"
    >
      <wechatdialog
        ref="wechatdialogview"
        @callback="callback"
      />
    </el-dialog>
  </GlobalWindow>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import GlobalWindow from '@/components/GlobalWindow.vue'
import { getAccountList } from '@/api/massiveAdvertising/accountList.js'
import wechatdialog from './wechatdialog.vue'
export default {
  name: 'CopyMpAdDialog',
  components: {
    GlobalWindow,
    PaginationRight,
    wechatdialog
  },
  props: {
    // campaign_ids: {}
  },
  data() {
    return {
      isVisibled: false,
      isLoading: false,
      total: 0,
      mpAdvertiserListParams: {
        account_id: null,
        account_name: null,
        type: null,
        account_status: null,
        page: 1, // 当前页码
        // pageSize: null // 显示数据条数
        // page: 1, // 当前页码
        page_size: 10 // 显示数据条数
      },
      selectData: [],
      mpAdvertiserList: null,
      copyMpAdvertParams: {
        account_ids: [],
        account_id: null,
        adgroup_id: null,
        campaign_id: null,
        campaign_type: null
      },
      options: [
        {
          value: '1',
          label: '是'
        },
        {
          value: '0',
          label: '否'
        }
      ],
      options1: [
        { value: '1', label: '是' },
        { value: '0', label: '否' }
      ],
      optionsCrop: [
        {
          value: '0',
          label: '不裁剪'
        },
        {
          value: '1',
          label: '裁剪'
        },
        {
          value: '2',
          label: '四宫格'
        },
        {
          value: '3',
          label: '模糊化'
        }
      ],
      currency: {
        // 控制修改通用的
        cropNum: '',
        is_title: '0',
        is_notice: '0',
        is_repeat_submit: '0',
        launch_id: '',
        source_num: '',
        statuser: 0
      },
      adgroup_items: [],
      pickerOptions: {
        disabledDate(date) {
          const today = new Date()
          today.setDate(today.getDate() - 1) // 获取昨天的日期

          return date <= today
        }
      },
      rowData: {},
      type: null,
      allindex: null,
      dialogVisible: false
    }
  },
  created() {
    window.This = this
  },
  methods: {
    fetchPageSize(e) {
      this.mpAdvertiserListParams.page_size = e
      this.fetchMpAdvertiserList()
    },
    fetchCurrentPage(e) {
      this.mpAdvertiserListParams.page = e
      this.fetchMpAdvertiserList()
    },
    getRowKeys(row) {
      return row.id // 每条数据的唯一识别值
    },

    open(rowData, type) {
      console.log('rowData, type:', rowData, type)
      this.type = type
      if (type === 'batch') {
        this.adgroup_items = rowData
      } else {
        this.rowData = rowData
      }
      this.fetchMpAdvertiserList()
      this.isVisibled = true
    },

    // 获取广告主列表
    fetchMpAdvertiserList() {
      this.isLoading = true
      getAccountList({
        keyword: this.mpAdvertiserListParams.account_id,
        account_name: this.mpAdvertiserListParams.account_name,
        type: this.mpAdvertiserListParams.type,
        account_status: this.mpAdvertiserListParams.account_status,
        page: this.mpAdvertiserListParams.page,
        page_size: this.mpAdvertiserListParams.page_size
      }).then(res => {
        this.mpAdvertiserList = res.data.list
        // const duplicateData = JSON.parse(JSON.stringify(res.data.list[0]))
        // res.data.list[0].id = 5
        // this.mpAdvertiserList = [res.data.list[0], duplicateData]
        this.total = res.data.total
        this.isLoading = false
      })
    },
    clearSelect() {
      this.$refs.multipleTable.clearSelection()
    },

    // 初始化列表数据
    handleSelectionChange(data) {
      const res = []
      const datas = []
      data.forEach(item => {
        res.push(item.account_id)
        const s4 = this.selectData.filter(it => {
          return it.id === item.id
        })
        console.log('s4:', s4)
        datas.push({
          ...item,
          num: s4.length ? s4[0].num : 1, // 复制的量
          name: s4.length ? s4[0].name : null, // 备注
          remark: s4.length ? s4[0].remark : null, // 备注
          // pages_handle: s4.length ? s4[0].pages_handle : null, // 原生页
          tianshu: s4.length ? s4[0].num : 1, // 复制的量
          operation: s4.length ? s4[0].operation : 'ENABLE', // 复制的量
          jiange: s4.length ? s4[0].jiange : 0, // 截止天数
          is_title: s4.length ? s4[0].is_title : '0', // 是否修改标题
          is_notice: s4.length ? s4[0].is_notice : '0', // 是否通知
          is_repeat_submit: s4.length ? s4[0].is_repeat_submit : '0', // 是否重复提交
          begin_time: s4.length ? s4[0].begin_time : this.formatDate(new Date()),
          end_time: s4.length ? s4[0].begin_time : this.formatDate(new Date().setFullYear(new Date().getFullYear() + 1)),
          app_id: s4.length ? s4[0].app_id : null, // 投放产品
          keywords: s4.length ? s4[0].keywords : null, // 自定义标签
          material_num: s4.length ? s4[0].material_num : 1, // 素材数量
          material_source: s4.length ? s4[0].material_source : 1, // 素材来源
          url_id: s4.length ? s4[0].url_id : '',
          url_remark: s4.length ? s4[0].url_remark : '',
          budget_mode: s4.length ? s4[0].budget_mode : 0,
          budget: s4.length ? s4[0].budget : '',
          search_bid_ratio: s4.length ? s4[0].search_bid_ratio : ''
        })
      })
      this.selectData = datas
      this.copyMpAdvertParams.account_ids = res
    },
    formatDate(date) {
      const currentDate = new Date(date)
      currentDate.setDate(currentDate.getDate())

      const year = String(currentDate.getFullYear()).slice() // 获取年份的后两位
      const month = String(currentDate.getMonth() + 1).padStart(2, '0') // 获取月份（注意加1，因为月份从0开始）
      const day = String(currentDate.getDate()).padStart(2, '0') // 获取日期

      return `${year}-${month}-${day}`
    },
    searchMpAdvert() {
      // this.mpAdvertiserListParams.page = 1
      this.fetchMpAdvertiserList()
    },
    resetMpAdvertList() {
      this.mpAdvertiserListParams = {
        name: null,
        page: 1,
        page_size: 10
      }
      this.fetchMpAdvertiserList()
    },
    confirm() {
      if (this.selectData.length === 0) {
        this.$message({
          message: '请选择广告账户',
          type: 'error'
        })
        return
      }
      const isValidbool = this.selectData.every(item => item.app_id !== null && item.app_id.trim() !== '')
      // 根据检查结果返回提示
      if (!isValidbool) {
        this.$message({
          message: '请输入投放产品',
          type: 'error'
        })
        return
      }
      const isValid = this.selectData.every(item => item.keywords !== null && item.keywords.trim() !== '')
      // 根据检查结果返回提示
      if (!isValid) {
        this.$message({
          message: '请输入自定义标签',
          type: 'error'
        })
        return
      }
      console.log(11999, this.copyMpAdvertParams, this.selectData)

      const arr = []
      let project_ids = []

      for (let i = 0; i < this.selectData.length; i++) {
        arr.push({
          account_id: this.selectData[i].account_id,
          advertiser_name: this.selectData[i].advertiser_name,
          num: this.selectData[i].num,
          name: this.selectData[i].name,
          remark: this.selectData[i].remark,
          opt_status: this.selectData[i].operation,
          // pages_handle: this.selectData[i].pages_handle,
          begin_time: this.selectData[i].begin_time,
          end_time: this.selectData[i].end_time,
          app_id: this.selectData[i].app_id,
          keywords: this.selectData[i].keywords,
          material_num: Number(this.selectData[i].material_num),
          material_source: this.selectData[i].material_source,
          // eslint-disable-next-line eqeqeq
          url_id: this.selectData[i].url_id == '' ? 0 : this.selectData[i].url_id,
          budget_mode: this.selectData[i].budget_mode,
          // eslint-disable-next-line eqeqeq
          budget: this.selectData[i].budget_mode == 0 ? this.selectData[i].budget : '',
          search_bid_ratio: this.selectData[i].search_bid_ratio
        })
      }
      project_ids = this.type === 'batch' ? this.adgroup_items.map(e => e.project_id) : [this.rowData.project_id]
      // this.selectData.map(e => e.adgroup_id)
      const obj = {
        account_id: this.type === 'batch' ? this.adgroup_items[0].account_id : this.rowData.account_id,
        account_ids: arr,
        project_ids
      }
      console.log('adgroup_ids:', project_ids, arr, obj)

      this.$emit('quediantwo', obj, () => {
        this.copyMpAdvertParams.account_ids = null
        this.isVisibled = false
        this.currency = {
          cropNum: '',
          is_title: '0',
          is_notice: '0',
          is_repeat_submit: '0',
          launch_id: '',
          source_num: '',
          statuser: 0
        }
      })
      this.isVisibled = false
    },
    judge(item, event) {
      const text = event.target.value
      console.log('event', event)
      if (Number(text) < 1) {
        text === '' ? (item.num = 1) : (item.num = Math.abs(text))
      } else if (Number(text) > 50) {
        text === '' ? (item.num = 1) : (item.num = 50)
      }
    },
    judgekoiwsr(item, event) {
      // const text = event.target.value
      // console.log('event', event)
      // if (Number(text) < 300) {
      //   text === '' ? (item.budget = 300) : (item.budget = Math.abs(text))
      // } else if (Number(text) > 9999999) {
      //   text === '' ? (item.budget = 300) : (item.budget = 9999999)
      // }
      const numValueall = parseFloat(event.target.value)
      // eslint-disable-next-line eqeqeq
      if (numValueall < 300 && event.target.value != '') {
        item.budget = 300 // 纠正为最小值
        // eslint-disable-next-line eqeqeq
      } else if (numValueall > 9999999 && event.target.value != '') {
        item.budget = 9999999 // 纠正为最大值
      }
    },
    judgekqaw(item, event) {
      const numValue = parseFloat(event.target.value)
      const regex = /^\d*\.?\d{0,2}$/
      // 如果输入不符合格式，清空输入框
      // eslint-disable-next-line eqeqeq
      if (!regex.test(event.target.value)) {
        item.search_bid_ratio = event.target.value.slice(0, -1) // 删除最后一个字符
        return
      }
      // eslint-disable-next-line eqeqeq
      if (numValue < 1 && event.target.value != '') {
        item.search_bid_ratio = 1 // 纠正为最小值
        // eslint-disable-next-line eqeqeq
      } else if (numValue > 2 && event.target.value != '') {
        item.search_bid_ratio = 2 // 纠正为最大值
      }
    },
    judgetwo(item, event) {
      const text = event.target.value
      console.log('event', event)
      // if (Number(text) < 1) {
      //   text === '' ? (item.app_id = 1) : (item.app_id = Math.abs(text))
      // } else if (Number(text) > 50) {
      //   text === '' ? (item.app_id = 1) : (item.app_id = 50)
      // }
      if (Number(text) < 0) {
        text === '' ? (item.app_id = 0) : (item.app_id = Math.abs(text))
      }
    },
    judgethree(item, event) {
      const text = event.target.value
      console.log('event', event)
      if (Number(text) < 1) {
        text === '' ? (item.material_num = '') : (item.material_num = Math.abs(text))
      } else if (Number(text) > 30) {
        text === '' ? (item.material_num = 1) : (item.material_num = 30)
      }
    },
    judges(item, event) {
      const text = event.target.value
      // if (Number(text) < 30) {
      //   item.jiange = 30
      // }
      if (Number(text) < 30 && Number(text) !== 0) {
        item.jiange = 30
      }
    },
    updateDatarw(item) {
      console.log('222')
    },
    handleCurrencyCropBegin_time() {
      if (!this.currency.begin_time) {
        return
      }
      this.selectData.forEach(item => {
        item.begin_time = this.currency.begin_time
      })
    },
    handleCurrencyCropEnd_time() {
      if (!this.currency.end_time) {
        return
      }
      this.selectData.forEach(item => {
        item.end_time = this.currency.end_time
      })
    },
    handleCurrencyCropNum() {
      if (!this.currency.cropNum) {
        return
      }
      this.selectData.forEach(item => {
        item.num = this.currency.cropNum
      })
    },
    handleCurrencyCropNumse() {
      if (!this.currency.launch_id) {
        return
      }
      this.selectData.forEach(item => {
        item.app_id = this.currency.launch_id
      })
    },
    handleCurrencyCropNumsuerw() {
      if (!this.currency.source_num) {
        return
      }
      this.selectData.forEach(item => {
        if (this.currency.source_num > 30) {
          item.material_num = 30
        } else {
          item.material_num = this.currency.source_num
        }
      })
    },
    handleCurrencyCropNumsuerwyuw() {
      if (!this.currency.objyunum) {
        this.selectData.forEach(item => {
          item.budget = ''
        })
        return
      }
      console.log('this.currency.objyunum', this.currency.objyunum)
      // const numValueall = parseFloat(this.currency.objyunum)
      if (this.currency.objyunum < 300) {
        this.selectData.forEach(item => {
          item.budget = 300
        })
      } else if (this.currency.objyunum > 9999999) {
        this.selectData.forEach(item => {
          item.budget = 9999999
        })
      } else {
        this.selectData.forEach(item => {
          item.budget = this.currency.objyunum
        })
      }
    },
    handleCurrencyCropNumschujiaxs() {
      const regex = /^\d*\.?\d{0,2}$/
      // 如果输入不符合格式，清空输入框
      // eslint-disable-next-line eqeqeq
      if (!regex.test(this.currency.chujiaxishu)) {
        return
      }
      console.log('this.currency.chujiaxishu', this.currency.chujiaxishu)
      // eslint-disable-next-line eqeqeq
      if (this.currency.chujiaxishu < 1 && this.currency.chujiaxishu != '') {
        this.selectData.forEach(item => {
          item.search_bid_ratio = 1
        })
        // eslint-disable-next-line eqeqeq
      } else if (this.currency.chujiaxishu > 2 && this.currency.chujiaxishu != '') {
        this.selectData.forEach(item => {
          item.search_bid_ratio = 2
        })
        // eslint-disable-next-line eqeqeq
      } else if (this.currency.chujiaxishu == '' || this.currency.chujiaxishu == null) {
        console.log('空')
        this.selectData.forEach(item => {
          item.search_bid_ratio = ''
        })
      } else {
        this.selectData.forEach(item => {
          item.search_bid_ratio = this.currency.chujiaxishu
        })
      }
    },
    handleParams(value) {
      console.log('value:', value)
      const str = /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、 ]/gim
      // this.mpAdvertiserListParams.name = value.replace(str, ',')
      const temp = value.replace(str, ',')
      const str1 = /(,){1,}/gim
      // this.mpAdvertiserListParams.name = this.mpAdvertiserListParams.name.replace(str1, ',')
      const temp1 = temp.replace(str1, ',')
      return temp1
    },
    inwerwq(item) {
      console.log('item', item)
      const index = this.selectData.findIndex(itemm => itemm.id === item.id)
      // eslint-disable-next-line eqeqeq
      if (index != -1) {
        console.log('找到id的索引值', index)
        this.allindex = index
        this.dialogVisible = true
        this.$nextTick(() => {
          this.$refs.wechatdialogview.send(1)
        })
      } else {
        console.log('没找到id')
      }
    },
    callback(item, alltype) {
      this.dialogVisible = false
      // eslint-disable-next-line eqeqeq
      if (alltype == 1) {
        console.log('this.allindex', this.allindex, this.selectData)
        this.selectData[this.allindex].url_id = item.id
        this.selectData[this.allindex].url_remark = item.remark
      } else {
        console.log('this.selectData', this.selectData)
        this.selectData.map(itemr => {
          itemr.url_id = item.id
          itemr.url_remark = item.remark
        })
      }
    },
    allchooserw() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.wechatdialogview.send(2)
      })
    },
    cuchangerstatus(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        this.selectData.forEach(item => {
          item.budget_mode = 0
        })
      } else {
        this.selectData.forEach(item => {
          item.budget_mode = -1
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.center-container {
  margin-top: 20px;
  display: flex;
  .center-left {
    width: 100%;
  }
  .center-right {
    margin-left: 50px;
    // width: 500px;
    // max-height: 500px;
    overflow: auto;
    td {
      padding: 4px;
    }
  }

  .input {
    height: 30px;
    width: 69px;
    padding-left: 5px;
    border: 1px solid #bfbfbf;
    border-radius: 5px;
  }
}
::v-deep .center-container .center-left {
  width: 100%;
}
.fowwr {
  width: 50px;
}
.wlewrw {
  text-align: center;
}
</style>
